var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassionWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "contenitore",
    width: 70,
    height: 70,
    transform: "translate(283.702 633)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "passione_per_il_lavoro",
    "data-name": "passione per il lavoro",
    transform: "translate(-102.702 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_29",
    "data-name": "Gruppo di maschere 29",
    transform: "translate(-181 -334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3205",
    "data-name": "Raggruppa 3205",
    transform: "translate(24236.701 -18105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fondo",
    d: "M3.47,62.626s-5.861-9.555-2.35-18.65,10.2-6.939,19.592-16.179C32.1,16.573,40.1,15.956,50.265,20.858c5.751,2.773,6.681,14.181,15.831,21.265,8.251,6.387,1.52,17.27-2.81,18.965a22.119,22.119,0,0,1-7.271,1.7S49.5,85.757,30.1,84.968,3.47,62.626,3.47,62.626Z",
    transform: "translate(-23952.012 18722.012)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3207",
    "data-name": "Raggruppa 3207",
    transform: "translate(-6 2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_89",
    "data-name": "Ellisse 89",
    cx: 4.831,
    cy: 4.988,
    rx: 4.831,
    ry: 4.988,
    transform: "translate(-23936.898 18746.623) rotate(-28.663)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_90",
    "data-name": "Ellisse 90",
    cx: 3.981,
    cy: 3.981,
    r: 3.981,
    transform: "translate(-23934.246 18745.982)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1086",
    "data-name": "Tracciato 1086",
    d: "M513.523,423.363l-.512,1.448.753,4.358,3.1,2.578,2.464-3.81-1.186-3.6-.89-1h0a.658.658,0,0,0-.642-.721l-1.943-.038a1.192,1.192,0,0,0-1.147.794Z",
    transform: "translate(-24445.924 18332.689)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1087",
    "data-name": "Tracciato 1087",
    d: "M225.573,494.071h1.987l.274-7.664h-2.262Z",
    transform: "translate(-24149.727 18307.887)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1088",
    "data-name": "Tracciato 1088",
    d: "M0,0H6.245V2.413H2.413A2.413,2.413,0,0,1,0,0H0Z",
    transform: "translate(-23918.334 18803.801) rotate(179.995)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1089",
    "data-name": "Tracciato 1089",
    d: "M139.69,494.071h1.987l.945-7.664h-2.933Z",
    transform: "translate(-24077.762 18307.887)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1090",
    "data-name": "Tracciato 1090",
    d: "M0,0H6.245V2.413H2.413A2.413,2.413,0,0,1,0,0H0Z",
    transform: "translate(-23932.254 18803.801) rotate(179.995)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1091",
    "data-name": "Tracciato 1091",
    d: "M576.06,377.355a1.63,1.63,0,0,1,.381,2.47l1.643,3.342-1.787,1.494-2.255-4.752a1.639,1.639,0,0,1,2.017-2.554Z",
    transform: "translate(-24496.662 18370.777)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1092",
    "data-name": "Tracciato 1092",
    d: "M495.659,445.378a23.994,23.994,0,0,1-2.9-.214,1.158,1.158,0,0,1-.973-1.451l2.151-7.964-1.732-4.86a2.184,2.184,0,0,1,1.206-2.743l2.379-1.006.715,4.427,1.7,2.148a.554.554,0,0,0,.918-.074l1.294-2.319-1.057-4.261,1.576.186a2.735,2.735,0,0,1,2.255,1.821,7.3,7.3,0,0,1,.121,4.363l-.653,2.32,1.146,7.41a1.509,1.509,0,0,1-1.332,1.733,15.19,15.19,0,0,1-2.207.092,1.447,1.447,0,0,1-1.359-1.179.207.207,0,0,0-.4,0q-.091.324-.2.721C498.139,445.168,497.029,445.378,495.659,445.378Z",
    transform: "translate(-24428.107 18328.928)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1093",
    "data-name": "Tracciato 1093",
    d: "M551.014,408.029a1.492,1.492,0,0,1-.576-.114,1.416,1.416,0,0,1-.846-1.027,1.713,1.713,0,0,1,.883-1.839l4.643-2.521-.254-1a.806.806,0,0,1,.312-.832l1.2-.889a.767.767,0,0,1,.648-.137.677.677,0,0,1,.45.373l.622,1.343a2.443,2.443,0,0,1-.979,3.044l-5.207,3.336A1.663,1.663,0,0,1,551.014,408.029Z",
    transform: "translate(-24476.547 18351.9)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1094",
    "data-name": "Tracciato 1094",
    d: "M481.3,543.65l-.049,0-2.53-.1a.729.729,0,0,1-.68-.8l2.568-24.7,6.738-2.45,3.968,2.245,4.341,23.935a.729.729,0,0,1-.543.842l-.01,0-2.59-.064a.731.731,0,0,1-.858-.491l-5.515-19.354a.243.243,0,0,0-.468.022l-3.661,20.349A.727.727,0,0,1,481.3,543.65Z",
    transform: "translate(-24416.621 18254.742)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1095",
    "data-name": "Tracciato 1095",
    d: "M506.415,363.013a1.594,1.594,0,1,0,2.848.758,2.059,2.059,0,0,0,1.814,2.317,2.388,2.388,0,0,0,2.415-1.847,2.849,2.849,0,0,0-1.213-2.88,3.547,3.547,0,0,0-3.18-.314A6.135,6.135,0,0,0,506.415,363.013Z",
    transform: "translate(-24440.158 18384.436)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3205-2",
    "data-name": "Raggruppa 3205",
    transform: "translate(-23933.02 18758.355) rotate(21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_606",
    "data-name": "Rettangolo 606",
    width: 8.847,
    height: 12.847,
    transform: "translate(0 1.953) rotate(-12.753)",
    fill: "#0096cc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_608",
    "data-name": "Rettangolo 608",
    width: 5.312,
    height: 0.885,
    transform: "translate(1.847 2.962) rotate(-12.753)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_609",
    "data-name": "Rettangolo 609",
    width: 7.083,
    height: 0.221,
    transform: "translate(1.455 5.243) rotate(-12.753)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_610",
    "data-name": "Rettangolo 610",
    width: 7.083,
    height: 0.221,
    transform: "translate(1.57 5.746) rotate(-12.753)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_611",
    "data-name": "Rettangolo 611",
    width: 7.083,
    height: 0.221,
    transform: "translate(1.684 6.25) rotate(-12.753)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_612",
    "data-name": "Rettangolo 612",
    width: 3.394,
    height: 0.221,
    transform: "translate(1.798 6.755) rotate(-12.753)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_613",
    "data-name": "Rettangolo 613",
    width: 3.91,
    height: 0.221,
    transform: "translate(1.912 7.259) rotate(-12.753)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_614",
    "data-name": "Rettangolo 614",
    width: 7.083,
    height: 0.221,
    transform: "translate(2.026 7.762) rotate(-12.753)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_615",
    "data-name": "Rettangolo 615",
    width: 7.083,
    height: 0.221,
    transform: "translate(2.138 8.265) rotate(-12.753)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_616",
    "data-name": "Rettangolo 616",
    width: 6.566,
    height: 0.221,
    transform: "translate(2.252 8.769) rotate(-12.753)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_617",
    "data-name": "Rettangolo 617",
    width: 7.083,
    height: 0.221,
    transform: "translate(2.366 9.272) rotate(-12.753)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_618",
    "data-name": "Rettangolo 618",
    width: 3.689,
    height: 0.221,
    transform: "translate(2.481 9.776) rotate(-12.753)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_624",
    "data-name": "Rettangolo 624",
    width: 4.279,
    height: 2.951,
    transform: "translate(5.267 10.053) rotate(-12.753)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1096",
    "data-name": "Tracciato 1096",
    d: "M455.617,326.913a12.727,12.727,0,0,0-2.148-3.484A4.308,4.308,0,0,0,449.786,322a2.642,2.642,0,0,0-2.215,2.933,1.428,1.428,0,0,1-1.1,1.54,3.616,3.616,0,0,1-2.048-.2,5.935,5.935,0,0,0-2.03-.437,2.908,2.908,0,0,0-2.61,2.776,3.629,3.629,0,0,0,2.173,3.3,4.862,4.862,0,0,0,4.053-.165A7.462,7.462,0,0,0,449,328.892a3.759,3.759,0,0,1,5.387-.855.853.853,0,0,0,1.153-.092A.9.9,0,0,0,455.617,326.913Z",
    transform: "translate(-24384.561 18417)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1100",
    "data-name": "Tracciato 1100",
    d: "M486.318,480.5a1.63,1.63,0,0,0-2.327-.911l-2.913-2.188-.7,2,3.011,2.509a1.639,1.639,0,0,0,2.933-1.411Z",
    transform: "translate(-24418.574 18286.746)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1101",
    "data-name": "Tracciato 1101",
    d: "M477.424,446.184a.677.677,0,0,1-.362-.105l-1.251-.791a2.443,2.443,0,0,1-.829-3.088l2.565-5.627a1.6,1.6,0,0,1,1.151-.927,1.415,1.415,0,0,1,1.268.4,1.713,1.713,0,0,1,.256,2.024l-2.533,4.636.758.706a.807.807,0,0,1,.189.868l-.523,1.4a.769.769,0,0,1-.47.467A.687.687,0,0,1,477.424,446.184Z",
    transform: "translate(-24413.857 18321.75)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1102",
    "data-name": "Tracciato 1102",
    d: "M376.645,721.324H341.586c-.062,0-.112-.072-.112-.162s.05-.162.112-.162h35.059c.062,0,.112.073.112.162S376.706,721.324,376.645,721.324Z",
    transform: "translate(-24286.256 18082.627)",
    fill: "#b8b8b8",
    stroke: "#b8b8b8",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3206",
    "data-name": "Raggruppa 3206",
    transform: "translate(-4 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_1103",
    "data-name": "Tracciato 1103",
    transform: "translate(-23922.254 18758.766)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38.49295043945313 27.21707725524902 L 1.748331904411316 27.21707725524902 C 0.8938019275665283 27.21707725524902 0.1985919028520584 26.6349983215332 0.1985919028520584 25.91952896118164 C 0.1983719021081924 25.66736793518066 0.1766218990087509 0.7037280201911926 0.1985719054937363 -0.8014019727706909 C 0.2024219036102295 -1.065341949462891 0.2000419050455093 -1.343981981277466 0.1977519094944 -1.613441944122314 C 0.1896819025278091 -2.560662031173706 0.1805319041013718 -3.634262084960938 0.4692519009113312 -3.925441980361938 C 0.5127019286155701 -3.969261884689331 0.5594618916511536 -3.98881196975708 0.620871901512146 -3.98881196975708 C 0.6276218891143799 -3.98881196975708 0.6344419121742249 -3.988571882247925 0.6414418816566467 -3.988101959228516 C 0.9281119108200073 -3.968991994857788 1.398561954498291 -3.213551998138428 1.776581883430481 -2.606532096862793 C 2.343472003936768 -1.696221947669983 2.878921985626221 -0.8364019989967346 3.498071908950806 -0.8364019989967346 L 38.49295043945313 -0.8364019989967346 C 39.34748077392578 -0.8364019989967346 40.04269027709961 -0.2543219923973083 40.04269027709961 0.4611480236053467 L 40.04269027709961 25.91952896118164 C 40.04269027709961 26.6349983215332 39.34748077392578 27.21707725524902 38.49295043945313 27.21707725524902 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.6208724975585938 -3.788812637329102 C 0.61895751953125 -3.788812637329102 0.617431640625 -3.788749694824219 0.616455078125 -3.788749694824219 C 0.6161689758300781 -3.788749694824219 0.6159324645996094 -3.788753509521484 0.6157455444335938 -3.788768768310547 C 0.600830078125 -3.776466369628906 0.4918861389160156 -3.669670104980469 0.4351234436035156 -3.146501541137695 C 0.3883705139160156 -2.71556282043457 0.3931312561035156 -2.15614128112793 0.3977432250976563 -1.615142822265625 C 0.4000511169433594 -1.344541549682617 0.4024314880371094 -1.064731597900391 0.3985519409179688 -0.798492431640625 C 0.3766212463378906 0.705108642578125 0.3983726501464844 25.66720771789551 0.398590087890625 25.91952896118164 C 0.398590087890625 26.52471733093262 1.004081726074219 27.0170783996582 1.748332977294922 27.0170783996582 L 38.49295043945313 27.0170783996582 C 39.23720169067383 27.0170783996582 39.84269332885742 26.52471733093262 39.84269332885742 25.91952896118164 L 39.84269332885742 0.4611473083496094 C 39.84269332885742 -0.1440410614013672 39.23720169067383 -0.6364021301269531 38.49295043945313 -0.6364021301269531 L 3.498073577880859 -0.6364021301269531 C 2.767860412597656 -0.6364021301269531 2.203891754150391 -1.542022705078125 1.6068115234375 -2.500812530517578 C 1.338924407958984 -2.930973052978516 0.8412132263183594 -3.730173110961914 0.6245002746582031 -3.788681030273438 L 0.6208724975585938 -3.788812637329102 M 0.6208686828613281 -4.188806533813477 C 0.631988525390625 -4.188806533813477 0.6432266235351563 -4.18842887878418 0.6547431945800781 -4.187662124633789 C 1.474933624267578 -4.13298225402832 2.531723022460938 -1.036401748657227 3.498073577880859 -1.036401748657227 L 38.49295043945313 -1.036401748657227 C 39.45930099487305 -1.036401748657227 40.24269104003906 -0.3659324645996094 40.24269104003906 0.4611473083496094 L 40.24269104003906 25.91952896118164 C 40.24269104003906 26.74660873413086 39.45930099487305 27.41707801818848 38.49295043945313 27.41707801818848 L 1.748332977294922 27.41707801818848 C 0.7819709777832031 27.41707801818848 -0.001407623291015625 26.74660873413086 -0.001407623291015625 25.91952896118164 C -0.001407623291015625 25.91952896118164 -0.02363967895507813 0.719757080078125 -0.001407623291015625 -0.8043212890625 C 0.02050018310546875 -2.3070068359375 -0.1601829528808594 -4.188806533813477 0.6208686828613281 -4.188806533813477 Z",
    stroke: "none",
    fill: "#b8b8b8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1104",
    "data-name": "Tracciato 1104",
    d: "M677.154,228.659l-1.831-1.652c-6.5-5.971-10.8-9.846-10.8-14.673a6.867,6.867,0,0,1,6.945-6.987,7.47,7.47,0,0,1,5.682,2.668,7.47,7.47,0,0,1,5.682-2.668,6.867,6.867,0,0,1,6.945,6.987c0,4.827-4.293,8.7-10.8,14.673Z",
    transform: "translate(-24579.291 18555.564)",
    fill: "#03518c"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassionWork);
export default __webpack_public_path__ + "static/media/passion_work.be8220bed4b125783bd9953b70ccdf0c.svg";
export { ForwardRef as ReactComponent };